// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__36-cM","content":"styles_content__nNzZJ","checkbox":"styles_checkbox__2Cuus","checkboxLabel":"styles_checkboxLabel__3mA_d"};